export default "__VITE_ASSET__COMXpWdJ__"